import { gql, useMutation } from '@apollo/client';
import {useGetSelectedSport} from "../utilHooks/useGetSelectedSport/useGetSelectedSport";

const REFETCH_DEFAULT_TRENDS = gql`
    query GetDefaultTrends($sport: String!) {
        defaultTrends(sport: $sport) {
            id
            trend
        }
    }
`;

const LOGIN_USER_MUTATION = gql`
  mutation LoginUser($email: String!, $password: String!) {
    loginUser(email: $email, password: $password) {
      id
      email
      token
    }
  }
`;

const LOGIN_USER_WITH_OAUTH_MUTATION = gql`
  mutation LoginUserWithOAuth($accessToken: String!) {
    loginUserWithOAuth(accessToken: $accessToken) {
      id
      email
      token
      profilePictureUrl
    }
  }
`;

export const useLoginUser = () => {
    const [executeMutation, { data, loading, error, reset }] = useMutation(LOGIN_USER_MUTATION);
    const {getSelectedSport} = useGetSelectedSport();
    const sport = getSelectedSport();
    const loginUser = (email: string, password: string) => {
        return executeMutation({ variables: { email, password },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: REFETCH_DEFAULT_TRENDS,
                    variables: { sport },
                },
                'GetUserTrends',
            ],
        });
    };

    return { loginUser, data, loading, error, reset };
};

export const useLoginUserWithOAuth = () => {
    const [executeOAuthLogin, { data, loading, error, reset }] = useMutation(LOGIN_USER_WITH_OAUTH_MUTATION);
    const loginUserWithOAuth = (accessToken: string) => {
        const loggedInUser = executeOAuthLogin({ variables: { accessToken } });
        return loggedInUser
    };

    return { loginUserWithOAuth, data, loading, error, reset };
};

export const setUserToken = (token: string) => {
    localStorage.setItem('token', token)
}
